/**
 * Copyright (c) StrangeBee 2023
 */

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import { ReactElement, memo } from 'react';

import './UserMFAButton.scss';

interface IUserMFAButtonProps {
    hasMFA: boolean;
    tooltip?: string;
    onClick: () => void;
    className?: string | string[];
}

const UserMFAButton = ({ hasMFA, tooltip, onClick, className }: IUserMFAButtonProps): ReactElement => {
    const content = (
        <ICONS.UserMFA className={classList(['user-mfa-button', className, { 'no-mfa': !hasMFA }])} onClick={onClick} />
    );

    return tooltip ? <THTooltip title={tooltip}>{content}</THTooltip> : content;
};

export default memo(UserMFAButton);
